import { API, axiosInstance } from "lib";

export const createStoreBuyer = (data = {}) => {
    return axiosInstance
      .post(API.BUYER, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const getBuyer = (data,filter) => {

    return axiosInstance
    .get(data?`${data}&${filter}`:`${API.BUYER}?${filter}`, {})
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const getSingleBuyer = (data = {}) => {
    return axiosInstance
      .get(`${API.BUYER}/${data}`, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const updateBuyer = (data = {}) => {
    return axiosInstance
      .patch(`${API.BUYER}/${data?.id}`, data.payload)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const deleteBuyer = (data = {}) => {
    return axiosInstance
      .delete(`${API.BUYER}/${data?.id}`, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };


  ///Category ---///

  export const createStoreCategory = (data = {}) => {
    return axiosInstance
      .post(API.CATEGORY, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const getCategory = (data,filter) => {
    return axiosInstance
    .get(data?`${data}?${filter}`:`${API.CATEGORY}?${filter}`, {})
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const getSingleCategory = (data = {}) => {
    return axiosInstance
      .get(`${API.CATEGORY}/${data}`, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const updateCategory = (data = {}) => {
    return axiosInstance
      .patch(`${API.CATEGORY}/${data?.id}`, data.payload)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const deleteCategory = (data = {}) => {
    return axiosInstance
      .delete(`${API.CATEGORY}/${data?.id}`, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };


  ///-------- Item ---///

  export const createStoreItem = (data = {}) => {
    return axiosInstance
      .post(API.ITEM, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const getItem = (data,filter) => {

    return axiosInstance
    .get(data?`${data}&${filter}`:`${API.ITEM}?${filter}`, {})
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const getItemAll = (data,filter) => {

    return axiosInstance
    .get(data?`${data}&${filter}`:`${API.ITEM}?${filter}`, {})
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };
  export const getSingleItem = (data = {}) => {
    return axiosInstance
      .get(`${API.ITEM}/${data}`, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const updateItem = (data = {}) => {
    return axiosInstance
      .patch(`${API.ITEM}/${data?.id}`, data.payload)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const deleteItem = (data = {}) => {
    return axiosInstance
      .delete(`${API.ITEM}/${data?.id}`, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };


  ///-------- Purchase ---///

  export const createStorePurchase = (data = {}) => {
    return axiosInstance
      .post(API.PURHASE, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const getPurchase = (data,filter) => {

    return axiosInstance
      .get(data?`${data}&${filter}`:`${API.PURHASE}?${filter}`, {})
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const getSinglePurches = (data = {}) => {
    return axiosInstance
      .get(`${API.PURHASE}/${data}`, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const updatePurchase = (data = {}) => {
    return axiosInstance
      .put(`${API.PURHASE}/${data?.id}`, data.payload)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const deletePurchase = (data = {}) => {
    return axiosInstance
      .delete(`${API.PURHASE}/${data?.id}`, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };


   ///-------- Transaction ---///

   export const createStoreTransaction = (data = {}) => {
    return axiosInstance
      .post(API.STOCK_TRANSACTION, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const getTransaction = (data,filter) => {

    return axiosInstance
      .get(data?`${data}&${filter}`:`${API.STOCK_TRANSACTION}?${filter}`, {})
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const getSingleTransaction = (data = {}) => {
    return axiosInstance
      .get(`${API.STOCK_TRANSACTION}/${data}`, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const updateTransaction = (data = {}) => {
    return axiosInstance
      .put(`${API.STOCK_TRANSACTION}/${data?.id}`, data.payload)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const deleteTransaction = (data = {}) => {
    return axiosInstance
      .delete(`${API.STOCK_TRANSACTION}/${data?.id}`, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

   ///-------- Transaction ---///

   export const createStoreChallan = (data = {}) => {
    return axiosInstance
      .post(API.CHALLAN, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const getChallan = (data,filter) => {

    return axiosInstance
      .get(data?`${data}&${filter}`:`${API.CHALLAN}?${filter}`, {})
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const getSingleChallan = (data = {}) => {
    return axiosInstance
      .get(`${API.CHALLAN}/${data}`, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const updateChallan = (data = {}) => {
    return axiosInstance
      .put(`${API.CHALLAN}/${data?.id}`, data.payload)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const deleteChallan = (data = {}) => {
    return axiosInstance
      .delete(`${API.CHALLAN}/${data?.id}`, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };


  /// Shop

   export const createStoreShop = (data = {}) => {
    return axiosInstance
      .post(API.SHOP, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const getShop = (data,filter) => {

    return axiosInstance
      .get(data?`${data}&${filter}`:`${API.SHOP}?${filter}`, {})
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const getSingleShop = (data = {}) => {
    return axiosInstance
      .get(`${API.SHOP}/${data}`, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const updateShop = (data = {}) => {
    return axiosInstance
      .put(`${API.SHOP}/${data?.id}`, data.payload)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

  export const deleteShop = (data = {}) => {
    return axiosInstance
      .delete(`${API.SHOP}/${data?.id}`, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        throw err;
      });
  };

